<template>
  <div class="tile is-ancestor is-vertical box is-12 zeromp">
    <div class="tile is-parent is-12 zeromp">
      <article class="tile is-child zeromp">
        <div class="content zeromp">
          <internnavbar />
        </div>
      </article>
    </div>
    <div class="tile is-vertical is-12 internbackground">
      <div class="tile is-parent is-vertical">
        <div class="tile is-child">
          <p class="indextitle">{{ proposta.nome }}</p>

          <div class>
            <div class id="tabela-propostas">
              <b-table :data="proposta.videos" :hoverable="true" :checkable="true">
                <template slot-scope="props">
                  <!-- colunas-->

                  <b-table-column label="Título">{{ props.row.titulo }}</b-table-column>

                  <b-table-column label="Descrição" class="descVideo">{{ props.row.descricao }}</b-table-column>

                  <b-table-column field="actions" label="Ações" width="180" centered>
                    <!-- detalhes -->
                    <b-tooltip label="Assitir" position="is-top" type="is-dark">
                      <button
                        class="button is-primary is-round"
                        id="info"
                        @click="video_url = props.row.url, isCardModalActive = true"
                      >
                        <b-icon icon="eye"></b-icon>
                      </button>
                    </b-tooltip>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
          <b-modal :active.sync="isCardModalActive" style="width=729; height=425;">
            <div class>
              <div class="card-content">
                <iframe
                  allowfullscreen
                  width="100%"
                  v-bind:src=" 'https://player.vimeo.com/video/'  + video_url.split('/')[2]"
                ></iframe>
              </div>
            </div>
          </b-modal>
        </div>
        <internfooter />
      </div>
    </div>
  </div>
</template>

<script>
import PropostaService from "@/services/PropostaService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";


export default {
  data() {
    return {
      proposta: {},
      video_url: "",
      isImageModalActive: false,
      isCardModalActive: false
    };
  },

  name: "TableVideoaula",
  props: ["proposta_id"],
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
  },
  created() {
    PropostaService.Info(this.proposta_id).then(result => {
      this.proposta = result.data;
    });
  },
};
</script>
<style scoped>
iframe {
  height: 60vh;
}
</style>